import { render, staticRenderFns } from "./LayoutBarraLateral.vue?vue&type=template&id=6e51dac3&scoped=true&"
import script from "./LayoutBarraLateral.vue?vue&type=script&lang=js&"
export * from "./LayoutBarraLateral.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBarraLateral.vue?vue&type=style&index=0&id=6e51dac3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e51dac3",
  null
  
)

export default component.exports